import React from "react";
import { Modal, ModalBody } from "reactstrap";

const DOCUMENT_TYPES = [
    "Driver License",
    "SSN",
    "Birth Certificate",
    "Passport",
    "Green Card",
    "EAD Card",
    "Arbitration Agreement",
    "Employee Handbook",
    "Notice to Employee Wage Theft",
    "SDI / PFL / UI Pamphlets",
    "NDA Confidentiality Agreement",
    "Employee's Withholding Allowance Certificate",
    "Employee's Withholding Certificate",
    "Employment Eligibility Verification"
];

export default function UploadDocumentSelectorModal({ isOpen, toggle, onSelect }) {
    return (
        <Modal isOpen={isOpen} toggle={toggle} contentClassName="custom-dark-modal">
            <ModalBody style={{ background: "#262523", padding: 30, borderRadius: 12 }}>
                <h3
                    style={{
                        color: "#ffd86b",
                        textAlign: "center",
                        marginBottom: 20,
                        fontWeight: 700
                    }}
                >
                    Choose Document Type
                </h3>

                {DOCUMENT_TYPES.map((doc) => (
                    <div
                        key={doc}
                        style={{
                            background: "#3a3a3a",
                            padding: "12px 18px",
                            borderRadius: 12,
                            marginBottom: 10,
                            color: "white",
                            textAlign: "center",
                            cursor: "pointer",
                            fontWeight: 600
                        }}
                        onClick={() => {
                            onSelect(doc);
                            toggle();
                        }}
                    >
                        {doc}
                    </div>
                ))}
            </ModalBody>
        </Modal>
    );
}